/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arr_inArray, elementHasClassName, elementHasOneOfClassNames, htmlspecialchars, mj_cloned_object, split_once, str_trim } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { getFromSession, setInSession } from './session-util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { postToBackend, postToBackend2 } from './fetch-util.js';
import { mjt } from './i18ntexts.js';

import { toggle_oc_container } from './oc-container-compat.js';
import { confirm_box } from './page-modal.js';
import { showInfoToast, showWarningToast } from './snackbar.js';
import { closeAllTooltips } from './page-tooltips.js';

import './meta-filter-widgets.js';
import './jquery.dynatree-custom.js';

import { MDMedia } from './media-data.js';
import { MDTrees } from './tree-data.js';
import { createSearchRequest } from './search-request.js';

import { MVSearchConstraints } from './search-constraints.js';
import { MVSearchOptions } from './search-options-view.js';
import { MVPageHistory } from './page-history.js';
import { MVTrees } from './trees.js';


/*
 * TODOs
 *  - refactor out "category tree view" module
 */
export let MVSearch = function($,mj) {

	// search form node (jquery object)
	var m_form = null;
	var m_search_string_elem = null;
	var m_search_string_ml_elem = null;
	var m_search_string_both_elems = null;

	// configuration
	var m_cfg;

	// current result info
	var m_cur_result = {
		result_list_id:		0,		// = list with results of search + color filter + options (before category filter)
		work_list_id:		0,		// = list with results after category filter
		text_result_count:	0,		// = count of results of text search (before color, metadata & category filters)
		result_count:		0,		// = count of results in result_list_id (before category filter)
		work_count:			0,		// = count of results in work_list_id (after category filter)
	};

	// category/tree filter states
	var m_filter = {
		categories: 	[],
		in_trees:		[],
		not_in_trees:	[],
		metasearch_trees: [],
		metasearch_values: [],
	};

	var m_cat_nav_mode = 'filter',
		m_conjunct_mode_trees = [],
		m_autocomplete_enabled = false,
		m_tes_ignore = false;

	// category counts
	var m_cc = {
		loaded:			false,
		unassigned:		[],
		assigned:		[],
		unknown_tree1:	[],
	};
	var m_cc_toid = null;
	var m_cc_request = null;

	// true when searching/filtering should not execute actually (used in initialization phases)
	var m_trigger_freezed = false;

	var m_default_trigger_cb = null;
	var m_cur_search_info_obj = null;
	var m_result_view_widget = null;
	var m_catmove_type = null;
	var m_catmove_lastaction = null;
	var m_color_idx = 0;
	var m_max_color_values = 10;


	function init( form, cfg, default_trigger_cb, result_view_widget ) {
		m_form = form;
		m_search_string_elem = $('#search-string');
		m_search_string_ml_elem = $('#search-ml-string');
		m_search_string_both_elems = $('#search-string,#search-ml-string');
		m_cfg = cfg;
		m_cat_nav_mode = getFromSession('category_navigation_mode','filter');
		m_default_trigger_cb = default_trigger_cb;
		m_result_view_widget = result_view_widget;


		MVSearchOptions.init(
			document.getElementById('sopts-content'),
			document.getElementById('sopts-title'),
			defaultToStar,
			triggerSearch,
			function onOptionChanged() {
				if( $('#trees-title > .active-marker').is(':visible') ) {
					if( m_cfg.search_by_extended_options_resets_categories ) {
						deselectTrees(false,false,false);
					} else if( m_cat_nav_mode==='browse' ) {
						if( m_cfg.search_by_extended_options_sets_filter_mode ) {
							setCategoryNavigationMode( 'filter', false,false, false,false,true );
						} else {
							// switching to "implicit filter mode" here, because options and browse mode do play together well :/
							deselectTrees(false,false,false);
						}
					}
				}
			}
		);


		function init_stage_1() {
			// create html skeleton for trees, once ...
			var mct_html='', tol=mj.trees_order.length;
			for( var i=0; i<tol; ++i ) {
				var tree_id=mj.trees_order[i], tree=mj.trees[tree_id];
				if( tree.visible ) {
					mct_html += '<div id="tree-title-'+tree_id+'" class="tree-title'+(tree.metasearch_mode?' metasearch':'')+'"><span class="tree-title-active-marker link" style="display:none" title="'+mjt('filter-active-hover')+'">'+mjt('filter-active')+'</span>'+htmlspecialchars(tree.name)+'</div>';
					mct_html += '<div id="tree-search-'+tree_id+'" class="tree-search"><input type="text" class="tree-search-box" maxlength="200"><span class="fa fa-search"></span></div>';
					mct_html += getDynatreeSkeletonHtml(tree);
				}
			}
			$('#media-cat-trees').html(mct_html);

			MDMedia.bindCategoriesChanged( function( media_ids, categories, trigger_tree_ids ) {
				updateCategoryCounts();
			} );
			MDMedia.bindMediaDeleted( function( media_ids ) {
				updateCategoryCounts(true);
			} );
			MDMedia.bindMediaRestored(function( media_ids, data ) {
				// console.log({w:'SEARCH bindMediaRestored',media_ids,data});
				updateCategoryCounts(true);
			} );
			m_form.submit( function(e) {
				resetExtSearch3(true);
				triggerSearch(true);
				e.preventDefault();
				//return false;
			} );
			$('#search-button').click( function(e) {
				m_form.submit();
				e.preventDefault();
			} );
			$('#search-reset').click( function(e) {
				e.preventDefault();
				e.stopPropagation();
				setSearchString('',false,true);
			} );
			var search_constraints_changed = function() {
				triggerSearch(false);
			};
			if( MVSearchConstraints.init($('#search-toggle-constraints'),'search[constraints]',search_constraints_changed) ) {
				$('#search-toggle-constraints').show();
			}
			$('#search-toggle-multi-1').click( function() {
				setSearchStringMultiline(true,true,false,true);
			} );
			$('#search-toggle-multi-2').click( function() {
				setSearchStringMultiline(false,true,false,true);
			} );
			$('#extended-search-toggle').click( function(e) {
				setExtSearchOpened(!isExtSearchOpened(),true,false,null);
				e.preventDefault();
			} );
			$('#media-cat-trees .tree-title-active-marker').click( function() {
				deselectTree( parseInt($(this).closest('#media-cat-trees .tree-title').attr('id').substr(11),10), true, true );
			} );
			$('#trees-title > .active-marker').click( function() {
				deselectTrees(true,true);
			} );
			$('#trees-content').on('mjscontainerclose', function() {
				if( $('#trees-title > .active-marker').is(':visible') ) deselectTrees(true,true);
			} );
		}

		function init_stage_3() {
			// shift/ctrl/alt + enter => submit
			m_search_string_ml_elem.off('keydown.MVSearch').on('keydown.MVSearch', function(e) {
				if( e.which==13 && ( e.ctrlKey || e.metaKey || e.shiftKey ) ) {
					m_form.submit();
					e.preventDefault();
					return false;
				}
			} );
			if( m_cfg.auto_complete_enabled ) {
				enableAutocomplete();
			} else {
				// enter in text search must trigger reset of extended options
				m_search_string_elem.off('keydown.MVSearch').on('keydown.MVSearch', function(e) {
					if( e.which==13 ) {
						m_form.submit();
						e.preventDefault();
						return false;
					}
				} );
			}
			enableColors();
			enableOptions();

			let $mcnmsi = $('#media-cat-nav-mode-switch-info');
			if( $mcnmsi.length ) {
				$mcnmsi = $mcnmsi.detach();
			}

			$('#media-cat-nav-mode-switch').empty().mjWidget({
				type: 'bool-toggle-switch',
				name: 'set_password',
				value: m_cat_nav_mode==='filter',
				labels: {
					left: {
						text: mjt('media-cat-nav-mode-browse'),
						title: mjt('media-cat-nav-mode-browse-info'),
						id: 'media-cat-nav-mode-browse'
					},
					right: {
						text: mjt('media-cat-nav-mode-filter'),
						title: mjt('media-cat-nav-mode-filter-info'),
						id: 'media-cat-nav-mode-filter'
					}
				},
				tooltip: {
					text: mjt('media-cat-nav-mode-switch-info-text', '!'),
					title: mjt('media-cat-nav-mode-switch-info-header', '!')
				},
				change: function() {
					const new_cat_nav_mode = $('#media-cat-nav-mode-switch').mjWidget('get') ? 'filter' : 'browse';
					if( new_cat_nav_mode!==m_cat_nav_mode ) {
						setCategoryNavigationMode( new_cat_nav_mode, true,false, true,true,false );
					}
					return false;
				}
			});
			if( $mcnmsi.length ) {
				$('#media-cat-nav-mode-switch').append($mcnmsi);
			}

			setCategoryNavigationMode( m_cat_nav_mode, false,true, false,false,false );
			if( m_default_trigger_cb ) m_default_trigger_cb(true,false);


			// TODO: move to its of MVTreeSearch ...
			$('#media-cat-trees .tree-search')
				.off('.MVTreeSearch')
				.on('keydown.MVTreeSearch', function(e) {
					if( e.keyCode==13 ) {

						// TODO: start search in in tree ..

						e.preventDefault();
						return false;
					}
				} );
		}

		MDTrees.refreshTreeData( function() {
			m_conjunct_mode_trees = [];
			var tol = mj.trees_order.length;
			for( var i=0; i<tol; ++i ) {
				var tree_id = mj.trees_order[i];
				var tree = mj.trees[tree_id];
				if( tree.visible && tree.conjunct_mode && tree.multifiling ) m_conjunct_mode_trees.push(tree_id);
			}
			init_stage_1();
			window.setImmediate( function() {
				var sftml = getFromSession('search_fulltext_multiline','0')==='1';
				setSearchStringMultiline(sftml,false,true,false);
				var eso = getFromSession('extended_search_opened','1')==='1';
				if( eso ) setExtSearchOpened(true,false,true,init_stage_3);
				else init_stage_3();
			} );
		} );
	}

	function convertMultilineInputToSearchString( mstr ) {
		if( mstr==='' ) {
			return '';
		}
		// split input into terms
		var terms_arr = str_trim(mstr.replace(/[\s,;|]+/g,' ')).split(' ');
		// combine terms into manja-compatible search expression
		return terms_arr.join(' | ');
	}

	function convertSearchStringToMultilineInput( sstr ) {
		// split input into terms
		var terms_arr = str_trim(sstr.replace(/[\s,;|]+/g,' ')).split(' ');
		// generate string with one term per line
		return terms_arr.join('\n');
	}

	function isSearchStringMultiline() {
		return m_search_string_ml_elem.css('display')!=='none';
	}

	function setSearchString( ftq, ftq_is_multiline, set_focus ) {
		if( ftq_is_multiline ) {
			m_search_string_elem.val(convertMultilineInputToSearchString(ftq));
			m_search_string_ml_elem.val(ftq);
		} else {
			m_search_string_elem.val(ftq);
			m_search_string_ml_elem.val(convertSearchStringToMultilineInput(ftq));
		}
		if( set_focus ) m_search_string_both_elems.filter(':visible').focus();
	}

	function getSearchString() {
		if( isSearchStringMultiline() ) {
			const sstr = convertMultilineInputToSearchString(m_search_string_ml_elem.val()||'');
			return str_trim(sstr);
		}
		return str_trim(m_search_string_elem.val()||'');
	}

	function defaultToStar() {
		if( getSearchString()==='' ) setSearchString('*',false);
	}


	function isCategoryBrowsing() {
		if( m_cur_result.work_list_id==0 ) return true;
		const sstring = getSearchString();
		if( sstring!=='*' && sstring!=='' ) return false;
		if( MVSearchConstraints.getSelectedTerms().length!==0 ) return false;
		if( $('#domcol-title > .active-marker').is(':visible') ) return false;
		if( MVSearchOptions.isActive() ) return false;
		return true;
	}

	function setCategoryCountHTML( target_elem, tree_id, cat_id, is_browsing ) {
		var tmp = cat_id>0 ? m_cc.assigned[cat_id] : ( tree_id==1 && cat_id==-1 ? m_cc.unknown_tree1 : m_cc.unassigned[tree_id] );
		var oc = tmp ? tmp[1] : 0;
		while( target_elem.lastChild ) target_elem.lastChild.remove();	//target_elem.removeChild(target_elem.lastChild);
		var bold_elem = document.createElement('b');
		bold_elem.appendChild(document.createTextNode( is_browsing ? oc : (tmp?tmp[0]:'0') ));
		target_elem.appendChild(bold_elem);
		$(target_elem).data('files', oc);
		if( !is_browsing ) target_elem.appendChild(document.createTextNode('/'+oc));
	}

	function loadCategoryCountsFromJSONResponse( j ) {
		// inflate data ..
		for( const c in j.assigned ) {
			if( !j.assigned.hasOwnProperty(c) ) continue;
			const v = j.assigned[c];
			if( !v.hasOwnProperty(0) ) j.assigned[c] = [v,v];
		}
		for( const c in j.unassigned ) {
			if( !j.unassigned.hasOwnProperty(c) ) continue;
			const v = j.unassigned[c];
			if( !v.hasOwnProperty(0) ) j.unassigned[c] = [v,v];
		}
		// init full list of counts
		const lcp = mj.category_parents;
		let rcca = {};
		for( const c in lcp ) {
			if( !lcp.hasOwnProperty(c) ) continue;
			rcca[c] = [0,0];
		}
		// add counts to parents counts
		const cca = j.assigned || {};
		let cca_unknown_tree1 = [0,0];
		for( const c in cca ) {
			if( !cca.hasOwnProperty(c) ) continue;
			const xs = cca[c];
			if( lcp.hasOwnProperty(c) ) {
				// add counts to category node
				rcca[c] = [
					rcca[c][0] + xs[0],
					rcca[c][1] + xs[1],
				];
				// accumulate counts on parent category nodes
				for( var p=lcp[c]; p!=0 && lcp.hasOwnProperty(p); p=lcp[p] ) {
					rcca[p] = [
						rcca[p][0] + xs[0],
						rcca[p][1] + xs[1],
					];
				}
			} else {
				// add remaining counts to unknown nodes (=media contained in categories where we do not have access to..)
				cca_unknown_tree1 = [
					cca_unknown_tree1[0] + xs[0],
					cca_unknown_tree1[1] + xs[1],
				];
			}
		}
		m_cc = {
			loaded: true,
			assigned: rcca,
			unassigned: j.unassigned,
			unknown_tree1: cca_unknown_tree1,
		};
	}


	function updateCategoryCounts( delayed ) {
		$('#media-cat-trees .dtn').empty();
		if( m_cc_request!==null && m_cc_request.state && m_cc_request.state()==='pending' ) {
			// ABORT pending request
			// console.log(['ABORTING list-counts request.']);
			m_cc_request.abort();
			m_cc_request = null;
		}
		if( m_cc_toid!==null ) {
			// console.log(['ABORTING list-counts time-out.']);
			clearTimeout(m_cc_toid);
			m_cc_toid = null;
		}
		m_cc_toid = setTimeout( function updateCategoryCounts1() {
			m_cc_toid = null;
			m_cc_request = postToBackend('json/media/list-counts','list_id='+m_cur_result.result_list_id, function updateCategoryCounts2(j) {
				if( j ) {
					loadCategoryCountsFromJSONResponse(j);
					// if( true ) {
					// 	// show or hide nodes for "unsorted category" per tree
					// 	//...TODO...
					// 	// -> note: but must be visible on drag&drop
					// }
					// show or hide node for "unknown categories"
					var ct1 = $('#cat-tree-1');
					if( ct1.length ) {
						var dt1i = ct1.dynatree('instance');
						if( dt1i ) {
							var dt1 = dt1i.getTree();
							var dt1ucnode = dt1 && dt1.getNodeByKey ? dt1.getNodeByKey(-1) : null;
							if( m_cc.unknown_tree1[1] > 0 ) {
								if( dt1ucnode===null ) dt1.getRoot()._addNode({key:-1,xtype:'unknown',title:mjt('category-unknown')},-2);
							} else if( dt1ucnode!==null ) {
								dt1.getRoot()._delNode(-1);
							}
						}
					}
					// set counts on nodes
					var is_browsing = isCategoryBrowsing();
					// note: the query may take some seconds, and this makes it necessary to get "current" dtn_nodes here (not use the list from before the request)..
					//  because the user could have opened and/or closed some nodes meanwhile
					var dtn_nodes = $('#media-cat-trees .dtn');
					for( var i=dtn_nodes.length-1; i>=0; --i ) {
						var en = dtn_nodes[i];
						var id = split_once(en.id.substr(13),'-');
						setCategoryCountHTML(en,id[0],id[1],is_browsing);
					}
				}
			} );
		}, delayed ? 850 : 50 );
	}

	function _update_m_filter() {
		m_filter.categories = [];
		m_filter.in_trees = [];
		m_filter.not_in_trees = [];
		m_filter.metasearch_trees = [];
		m_filter.metasearch_values = [];

		$('#media-cat-trees .media-cat-tree').each( function() {
			let dti = $(this).dynatree('instance');
			if( dti ) {
				const keys = dti.getSelectedKeys();
				if( keys.length!==0 ) {
					const tree_id = dti.options.mjTreeId;
					const tree = mj.trees[tree_id];
					const metasearch_mode = tree.visible && tree.metasearch_mode;
					if( metasearch_mode ) {

						m_filter.metasearch_trees.push(tree_id);

						for( let k=0; k<keys.length; ++k ) {
							const key = keys[k];

							// // ???
							// m_filter.categories.push(key);

							const dtnode = dti.getNodeByKey(key);
							m_filter.metasearch_values.push( {
								tree_id: tree_id,
								cat_id: key,
								meta_id: tree.metasearch_meta_id,
								term: dtnode.data.title
							} );
						}
					} else {

						m_filter.in_trees.push(tree_id);

						for( let k=0; k<keys.length; ++k ) {
							const key = keys[k];
							if( key == 0 ) m_filter.not_in_trees.push(tree_id);
							else m_filter.categories.push(key);
						}
					}


				}
			}
		} );
	}

	function onCategorySelectionChange( trigger, interact_with_history ) {
		// console.time('onCategorySelectionChange');
		_update_m_filter();
		// update 'filter active' states
		$('#media-cat-trees .tree-title-active-marker').hide();
		for( let i=m_filter.in_trees.length-1; i>=0; --i ) {
			$('#tree-title-'+m_filter.in_trees[i]+' > .tree-title-active-marker').show();
		}
		for( let i=m_filter.metasearch_trees.length-1; i>=0; --i ) {
			$('#tree-title-'+m_filter.metasearch_trees[i]+' > .tree-title-active-marker').show();
		}
		$('#trees-title > .active-marker').toggle( m_filter.in_trees.length>0 || m_filter.metasearch_trees.length>0 );

		if( trigger ) {
			// trigger action accordingly...
			if( interact_with_history ) {
				if( !m_trigger_freezed ) MVPageHistory.go('sr',getSearchRequest(true).getTransientState(),'force');
			} else {
				triggerFilter();
			}
		} else if( interact_with_history ) {
			// update history, but don't trigger (even not indirectly through history!...)
			if( !m_trigger_freezed ) MVPageHistory.go('sr',getSearchRequest(true).getTransientState(),'suppress');
		}
		// console.timeEnd('onCategorySelectionChange');
	}

	function deselectTrees( trigger, interact_with_history, skip_onCategorySelectionChange ) {
		// console.time('deselectTrees');
		if( mj.trees_order===null ) return;
		for( var i=mj.trees_order.length-1; i>=0; --i ) {
			var tree_id = mj.trees_order[i];
			var tnode = $('#cat-tree-'+tree_id);
			if( tnode.length ) {
				var dti = tnode.dynatree('instance');
				if( dti ) dti.getTree().unselectAllNodes();
			}
		}
		if( !skip_onCategorySelectionChange ) onCategorySelectionChange(trigger,interact_with_history);
		// console.timeEnd('deselectTrees');
	}

	function deselectTree( tree_id, trigger, interact_with_history, skip_onCategorySelectionChange ) {
		var tnode = $('#cat-tree-'+tree_id);
		if( tnode.length ) {
			var dti = tnode.dynatree('instance');
			if( dti ) dti.getTree().unselectAllNodes();
		}
		if( !skip_onCategorySelectionChange ) onCategorySelectionChange(trigger,interact_with_history);
	}

	function setCategoryNavigationMode( mode, save, initial, trigger, interact_with_history, skip_onCategorySelectionChange ) {
		//console.log(['setCategoryNavigationMode(',mode,save,initial,trigger,interact_with_history,skip_onCategorySelectionChange]);
		m_cat_nav_mode = mode;
		if( save ) setInSession('category_navigation_mode',mode);
		// set button states
		$('#media-cat-nav-mode-switch').mjWidget('set', mode==='filter');

		if( initial ) {
			let hasVisibleBrowsableTrees = false;
			$('#media-cat-trees div[id^=cat-tree-]').each( function() {
				let dt = $(this).dynatree('getTree');
				let tree_id = dt.options.mjTreeId;
				let tree = mj.trees[tree_id];
				if( tree.visible && !tree.metasearch_mode ) {
					hasVisibleBrowsableTrees = true;
					return false; // break loop over trees
				}
			} );
			if( !hasVisibleBrowsableTrees ) {
				$('#media-cat-nav-mode-switch > *').hide();
			}
		}

		if( !initial ) {
			// reconfigure all dynatree widgets
			$('#media-cat-trees div[id^=cat-tree-]').each( function() {
				let dt = $(this).dynatree('getTree');
				let tree_id = dt.options.mjTreeId;
				let tree = mj.trees[tree_id];
				dt.enableMultiSelect(
					tree.metasearch_mode ? true : ( m_cat_nav_mode!=='browse' ),
					tree.metasearch_mode ? true : ( m_cat_nav_mode!=='browse' && !( tree.multifiling && tree.conjunct_mode ) )
				);
			} );
			// reset category selection
			if( trigger && interact_with_history ) {
				// console.log(['trigger && interact_with_history',trigger,interact_with_history]);
				triggerSearchByRequestObject(getSearchRequest(),false,null,false);
			} else if( m_default_trigger_cb ) {
				if( !skip_onCategorySelectionChange ) m_default_trigger_cb(trigger,interact_with_history);
			} else {
				deselectTrees(trigger,interact_with_history,skip_onCategorySelectionChange);
			}
		}
	}

	function setCategorySelectionStates( flatCategories, metaSearchValues ) {
		var csel = {};
		const cl = flatCategories.length;
		for( let i=0; i<cl; ++i ) {
			const cat_id = flatCategories[i][1];
			const tree_id = cat_id==-1 ? 1 : ( flatCategories[i][0] || MDTrees.getTreeIdFromCategoryId(cat_id) );
			let dt = $('#cat-tree-'+tree_id);
			if( !dt || dt.length===0 ) continue;
			let dti = dt.dynatree('instance');
			dt = dti ? dti.getTree() : null;
			if( dt && ('getNodeByKey' in dt) ) {
				let node = dt.getNodeByKey(cat_id);
				if( node==null && cat_id==-1 ) {
					// special case: the "unknown" category may not yet exist,
					// so, create it here
					dt.getRoot()._addNode({key:-1,xtype:'unknown',title:mjt('category-unknown')},-2);
					node = dt.getNodeByKey(cat_id);
				}
				if( node ) {
					const parent_cat_id = MDTrees.getParentIdFromCategoryId(cat_id);
					if( parent_cat_id===null || parent_cat_id===0 || !csel.hasOwnProperty(parent_cat_id) ) {
						// make visible only if parent was not already made visible .. (to avoid expanding too much nodes)
						node.makeVisible();
					}
					node.select(null,true,true);
					csel[cat_id] = true;
					// in browse mode: select only the first specified category
					if( m_cat_nav_mode==='browse' ) break;
				}
			}
		}
		for( let sv of metaSearchValues ) {
			const cat_id = sv.cat_id;
			let dt = $('#cat-tree-'+sv.tree_id);
			if( !dt || dt.length===0 ) continue;
			let dti = dt.dynatree('instance');
			dt = dti ? dti.getTree() : null;
			if( dt && ('getNodeByKey' in dt) ) {
				let node = dt.getNodeByKey(cat_id);
				if( node ) {
					const parent_cat_id = MDTrees.getParentIdFromCategoryId(cat_id);
					if( parent_cat_id===null || parent_cat_id===0 || !csel.hasOwnProperty(parent_cat_id) ) {
						// make visible only if parent was not already made visible .. (to avoid expanding too much nodes)
						node.makeVisible();
					}
					node.select(null,true,true);
					csel[cat_id] = true;
					// // in browse mode: select only the first specified category
					// if( m_cat_nav_mode==='browse' ) break;
				}
			}
		}
	}

	function disableAutocomplete() {
		if( m_autocomplete_enabled ) {
			m_search_string_elem.unautocomplete();
			$('.ac_results').hide();
			$(document).off('click.MVSearch');
			return true;
		}
		return false;
	}

	function enableAutocomplete() {
		m_autocomplete_enabled = true;

		function ac_formatResult( data )		{
			var val = data[0];
			var op = data[2];
			if( val.length ) {
				if( "!&|".indexOf(val[0])!=-1 ) {
					// !"term" &"term" |"term"
					return val[0]+'"'+val.substr(1)+'"';
				}
				if( op==='$' || op==='#' || "$#\"'".indexOf(val[0])!=-1 ) {
					// $term #term "term 'term
					return val+' ';
				}
			}
			if( data.length>=2 ) {
				if( data[1].substr(0,6)==='<span ' ) return val;						// is an operator
			}
			return '"'+val+'"';															// is text -> wrap in quotes
		}

		function ac_parse( data ) {
			let parsed = new Array(data.length);
			for( var i=0; i<data.length; i++ ) {
				// op  value  display_name
				const row0 = data[i];
				// reordered: value  display_name  op
				const row = [ row0[1], row0[2], row0[0] ];
				parsed[i] = {
					data: row,
					value: row[0],
					result: ac_formatResult(row) || row[0],
				};
			}
			return parsed;
		}

		function ac_formatItem( data, i, n, value, term )	{
			return data.length>=2 ? data[1] : htmlspecialchars(value);
		}


		m_search_string_elem
			.off('.MVSearch')
			.on('keydown.MVSearch', function(e) {
				// form submit for IE7/8 (must be installed before autocomplete!)
				if( e.keyCode==13 ) {
					var acr = $('.ac_results');
					m_search_string_elem.abortPendingRequest();
					if( acr.length && acr.css('display')!='none' && acr.find('.ac_over').length ) {
						// don't handle this
						return true;
					}
					m_form.submit();
					e.preventDefault();
					return false;
				}
			} )
			.autocomplete( 'json/media/search-suggestions', {
				delay: 200,
				minChars: 1,
				hasMinConstraints: function( value ) {
					if( value.length < 1 ) return false;
					if( value[0]==='$' || value[0]==='#' ) return value.length >= 1;	// 1 char is sufficient
					else if( value[0]==='!' ) return value.length >= 4;	// 1+3 chars minimum
					return value.length >= 3;	// 3 chars minimum
				},
				max: 17,
				extraParams: {
					'match_category_titles': m_cfg.search_in_category_titles?'1':'0',
				},
				autoFill: false,
				selectFirst: false,//true,
				multiple: true,
				multipleSeparator: ' ',
				width: 216,
				scrollHeight: 340,
				formatItem: ac_formatItem,
				parse: ac_parse,
				formatResult: ac_formatResult,
			} )
			.on('result.MVSearch', function( e, data, formatted ) {

				var op = data[2] || '';
				if( op==='$' || op==='op' ) {
					// dont yet trigger search,
					// -> user should add a term now ..
					e.preventDefault();
					return;
				}
				// $(this).val( $(this).val()+' ' );
				// console.log({ e, data, formatted, sel:$(this).selection(), val:$(this).val() });

				// search immediately after user selected a word from suggestions
				m_form.submit();
				e.preventDefault();
			} );

		// hide autocomplete results on click
		// (autocomplete plugin does not determine this on its own, it relies on blur() event of the input element)
		$(document)
			.off('.MVSearch')
			.on('click.MVSearch', function(evt) {
				$('.ac_results').hide();
			});
	}

	function resetColors( amount = 1, defStar = true ) {
		$('#domcol-content > .search-colors').empty();
		m_color_idx = 0;
		for(let i = 0; i < amount; i++) enableColor();
		updateColorsActiveMarker();
		if(defStar) defaultToStar();
	}

	function enableColors() {
		resetColors(1, false);
		function onreset(trigger = true) {
			resetColors(1, false);
			if(trigger) triggerSearch();
			return false;
		}
		$('#domcol-title > .active-marker').click( onreset );
		$('#domcol-content').on('mjscontainerclose', function() {
			if( $('#domcol-title > .active-marker').is(':visible') ) onreset();
		} );
	}

	function enableColor() {
		if($('.search-color-h', $('#domcol-content > .search-colors')).length >= m_max_color_values) return;
		var input_elem = $('<input id="search-color-'+m_color_idx+'-value" type="hidden" name="search[dominant-color-'+m_color_idx+']" value="" />');
		var html_elem =
		$('<div class="search-color-h" data-idx="'+m_color_idx+'">'+
			'<span id="search-color-'+m_color_idx+'" class="search-color">'+
				'<span class="preview background-transparent"></span>'+
				'<span class="preview-text">'+mjt(m_color_idx === 0 ? 'search-dominant-filter' : 'search-dominant-more')+'</span>'+
			'</span>'+
			'<span id="search-color-'+m_color_idx+'-reset" class="search-color-reset"></span>'+
		'</div>');
		$('#domcol-content > .search-colors').append(html_elem);
		$('#domcol-content > .search-colors').append(input_elem);

		var cp_restore_value = input_elem.val();//'transparent';
		cp_restore_value = cp_restore_value=='' ? 'transparent' : '#'+cp_restore_value;
		var cp_initial_color = '#dd2222';
		$('.search-color', html_elem).one( 'click', function() {
			var self = $(this);
			var accept_change_events = false;
			self.ColorPicker({
				color: cp_restore_value=='transparent' ? cp_initial_color : cp_restore_value,
				livePreview: false,
				onShow: function( colpkr ) {
					$(colpkr).fadeIn(200);
					cp_restore_value = input_elem.val();
					cp_restore_value = cp_restore_value=='' ? 'transparent' : '#'+cp_restore_value;
					self.ColorPickerSetColor( cp_restore_value=='transparent' ? cp_initial_color : cp_restore_value );
					accept_change_events = true;
					return false;
				},
				onHide: function( colpkr ) {
					$(colpkr).fadeOut(200);
					accept_change_events = false;
					if( cp_restore_value=='' || cp_restore_value=='transparent' || cp_restore_value=='rgba(0, 0, 0, 0)' ) $('span.preview',self).css( { backgroundColor:'transparent', color:'#aaaaaa' } );
					else $('span.preview',self).css( { backgroundColor:cp_restore_value, color:cp_restore_value } );
					return false;
				},
				onChange: function( hsb, hex, rgb ) {
					if( accept_change_events ) {
						$('span.preview',self).css( { backgroundColor:'#'+hex, color:'#'+hex } );
					}
				},
				onSubmit: function( hsb, hex, rgb, el ) {
					input_elem.val( hex );
					$('span.preview',self).css( { backgroundColor:'#'+hex, color:'#'+hex } );
					cp_restore_value = input_elem.val();
					cp_restore_value = cp_restore_value=='' ? 'transparent' : '#'+cp_restore_value;
					self.ColorPickerHide();
					$('.search-color-reset', html_elem).css( 'visibility', 'visible' );
					$('#domcol-title > .active-marker').show();
					$('span.preview-text', self).text('RGB '+rgb.r+'/'+rgb.g+'/'+rgb.b);
					if($(self).closest('.search-color-h').hasClass('hasActiveColor') === false) {
						$(self).closest('.search-color-h').addClass('hasActiveColor');
						enableColor();
					}
					defaultToStar();
					triggerSearch();
				},
			}).triggerHandler('click');
		} );
		$('.search-color-reset', html_elem).on('click', function() {
			let total_elements = $('.search-color-h', $('#domcol-content > .search-colors')).length;
			html_elem.remove();
			input_elem.remove();
			if($('.hasActiveColor', $('#domcol-content > .search-colors')).length === 0) resetColors(1, false);
			else if(total_elements == m_max_color_values) enableColor();
			triggerSearch();
		});
		m_color_idx++;
	}

	function updateColorsActiveMarker() {
		let active = false;
		$('#domcol-content > .search-colors > .search-color-h > .search-color').each(function(index, element) {
			let bc = $('span.preview', element).css('backgroundColor');
			if( bc!='transparent' && bc!='rgba(0, 0, 0, 0)' ) active = true;
		});
		$('#domcol-title > .active-marker').toggle( active );
		return active;
	}

	function setColor( idx, hex_value, update_active_marker ) {
		if( hex_value=='transparent' ) hex_value = '';
		let input_elements = $('#domcol-content > .search-colors input');
		let picker_elements = $('#domcol-content > .search-colors > .search-color-h');
		$(input_elements[idx]).val(hex_value);
		$('span.preview', $(picker_elements[idx])).css( { backgroundColor:(hex_value==''?'transparent':'#'+hex_value), color:(hex_value==''?'#aaaaaa':'#'+hex_value) } );
		$('.search-color-reset', $(picker_elements[idx])).css( 'visibility', hex_value=='' ? 'hidden' : 'visible' );
		if(hex_value) {
			$(picker_elements[idx]).addClass('hasActiveColor');
			let hex_parts = hex_value.match(/.{1,2}/g);
			$('span.preview-text', $(picker_elements[idx])).text('RGB '+parseInt(hex_parts[0], 16)+'/'+parseInt(hex_parts[1], 16)+'/'+parseInt(hex_parts[2], 16));
		} else {
			$(picker_elements[idx]).removeClass('hasActiveColor');
			$('span.preview-text', $(picker_elements[idx])).text(idx===0? mjt('search-dominant-filter') : mjt('search-dominant-more'));
		}
		if( update_active_marker ) updateColorsActiveMarker();
	}



	function enableOptions() {
		const optionsConfigurationList = mj.search.extended_options;
		if( optionsConfigurationList.length===0 ) {
			// completely remove extended options container
			$('#search-ext-options').remove();
			return true;
		}
		MVSearchOptions.setupOptionsView(optionsConfigurationList);
	}


	// reset all extended search options, and returns true if options were set, false otherwise
	function resetExtSearch( interact_with_history, skip_onCategorySelectionChange ) {
		if( $('#domcol-title > .active-marker, #trees-title > .active-marker').is(':visible') || MVSearchOptions.isActive() || MVSearchOptions.isSomeFilterActive() ) {
			resetColors();
			MVSearchOptions.resetOptions();
			deselectTrees(false,interact_with_history,skip_onCategorySelectionChange);
			return true;
		}
		return false;
	}

	function resetExtSearch3( skip_onCategorySelectionChange ) {
		if( m_cfg.search_by_text_resets_extended_options ) {
			return resetExtSearch(true,skip_onCategorySelectionChange);
		}
		//console.log(['resetExtSearch3 xxx',skip_onCategorySelectionChange]);
		// eslint-disable-next-line no-lonely-if
		if( $('#trees-title > .active-marker').is(':visible') ) {
			if( m_cat_nav_mode==='browse' ) {
				if( m_cfg.search_by_text_sets_filter_mode ) {
					setCategoryNavigationMode('filter', false,false, false,true,skip_onCategorySelectionChange );
				} else {
					// switching to "implicit filter mode" here, because options and browse mode do not so well play together :/
					deselectTrees(false,true,skip_onCategorySelectionChange);
				}
			}
			return true;
		}
		return false;
	}


	var m_cat_node_droppable_hover_count = 0;
	var m_droppable_cat_nodes_auto_expanded_on_over = [];
	var m_droppable_cat_nodes_dropping = false;

	function m_droppable_cat_nodes_auto_collapse( dt, dtnode, evt, avoid_collapsing_previous_nodes ) {
		var i;
		if( dtnode ) dtnode.makeVisible();
		var dont_collapse_ids = [];
		if( avoid_collapsing_previous_nodes ) {
			var parents_and_self = dtnode._parentList(true,true);
			var visit_descendants = function visit_descendants() {
				dont_collapse_ids.push(this.data.key);
			};
			for( i=0; i<parents_and_self.length; ++i ) {
				var pnode = parents_and_self[i],
					siblings = pnode.prevSiblings();
				dont_collapse_ids.push(pnode.data.key);
				for( var x=0; x<siblings.length; ++x ) {
					var snode = siblings[x];
					snode.visit( visit_descendants );
				}
			}
		} else if( dtnode ) {
			dont_collapse_ids = dtnode._parentIdList(true,true);
		}
		var collapsed_count = 0;
		for( i=m_droppable_cat_nodes_auto_expanded_on_over.length-1; i>=0; --i ) {
			var other_cat_id = m_droppable_cat_nodes_auto_expanded_on_over[i];
			if( dont_collapse_ids.indexOf(other_cat_id)==-1 ) {
				var other_node = dt.getNodeByKey(other_cat_id);
				if( other_node /**&& other_node.bExpanded**/ ) {
					other_node.collapse();
					m_droppable_cat_nodes_auto_expanded_on_over.splice(i,1);
					//--i;
					collapsed_count ++;
				}
			}
		}
		if( collapsed_count>0 && evt!==null ) {
			// refresh drop targets positions
			if( $.ui.ddmanager ) $.ui.ddmanager.prepareOffsets( $.ui.ddmanager.current, evt );
		}
	}

	function m_droppable_cat_nodes_activate( dt, activate, evt, ui ) {
		//var tree_id = dt.options.mjTreeId;
		m_cat_node_droppable_hover_count = 0;
		$('.drop-info',ui.helper).empty();
		m_droppable_cat_nodes_dropping = false;
		if( !activate ) m_droppable_cat_nodes_auto_collapse(dt,null,evt,false);
	}

	var m_cat_node_droppable_cfg_enabled = {
		greedy: true,
		accept: '.drag-media',
		addClasses: false,
		tolerance: 'pointer',
		hoverClass: 'drop-hover',
		//activeClass: 'drop-active',
		drop: function esdt_cat_node_drop( evt, ui ) {
			var draggable = ui.draggable;
			if( elementHasClassName(draggable[0],'drag-media') ) {
				var media_ids = draggable.data('drag_media_ids'),
					dtnode = this.dtnode,
					dt = dtnode.tree,
					cat_id = dtnode.data.key,
					tree_id = dt.options.mjTreeId,
					tree_info = mj.trees[tree_id];
				if( m_droppable_cat_nodes_dropping ) return;
				m_droppable_cat_nodes_dropping = true;
				m_droppable_cat_nodes_auto_collapse(dtnode.tree,dtnode,evt,false);
				m_droppable_cat_nodes_auto_expanded_on_over = [];
				// re-add hover class --- marks the target category, while in confirm_box()
				if( dtnode.span ) $(dtnode.span).addClass('drop-hover');
				var drop_done = function() {
					if( dtnode.span ) $(dtnode.span).removeClass('drop-hover');
					m_droppable_cat_nodes_dropping = false;
				};
				var _move_to_cat = function(media_ids, tree_id, cat_id, m_cur_result, dtnode)  {
					MDMedia.saveCategoryAssignment( media_ids, tree_id, cat_id==0 ? [] : [cat_id], function(updated_categories, all_data) {
						// update result view..
						drop_done();
						MDMedia.invalidateMediaCaches(media_ids);
						MDMedia.triggerFullMetaChanged(media_ids,null,true,false,function(tmp_data,tmp_actually_changed_ids) {
							//console.log( ['success_cb (3)',tmp_data,tmp_actually_changed_ids] );
							if( m_cur_result.work_list_id != 0 ) triggerFilter();
							let toast_title = media_ids.length == 1 ? mjt('move-media-to-category-1') : mjt('move-media-to-category-x');
							showInfoToast(toast_title.replace('%1', media_ids.length).replace('%2', dtnode.data.title), {
								undoToken: all_data['undo_token'],
								undoCallback: function() {
									MDMedia.invalidateMediaCaches(media_ids);
									MDMedia.triggerFullMetaChanged(media_ids,null,true,false,function(tmp_data,tmp_actually_changed_ids) {
										if( m_cur_result.work_list_id != 0 ) {
											triggerFilter();
										}
									});
									showInfoToast(mjt('move-media-to-category-canceled'));
								}
							});
						});
					}, function( error ) {
						drop_done();
						// TODO: localize error message:
						showWarningToast( 'Fehler, Kategorie konnte nicht zugewiesen werden. ' + error );
					} );
				};
				var _add_to_cat = function(media_ids, tree_id, cat_id, m_cur_result, dtnode)  {
					MDMedia.MDMedia.addCategoryAssignment( media_ids, tree_id, cat_id==0 ? [] : [cat_id], function(updated_categories, all_data) {
						// update result view..
						drop_done();
						MDMedia.invalidateMediaCaches(media_ids);
						MDMedia.triggerFullMetaChanged(media_ids,null,true,false,function(tmp_data,tmp_actually_changed_ids) {
							//console.log( ['success_cb (3)',tmp_data,tmp_actually_changed_ids] );
							if( m_cur_result.work_list_id != 0 ) triggerFilter();
							let toast_title = media_ids.length == 1 ? mjt('add-media-to-category-1') : mjt('add-media-to-category-x');
							showInfoToast(toast_title.replace('%1', media_ids.length).replace('%2', dtnode.data.title), {
								undoToken: all_data['undo_token'],
								undoCallback: function() {
									MDMedia.invalidateMediaCaches(media_ids);
									MDMedia.triggerFullMetaChanged(media_ids,null,true,false,function(tmp_data,tmp_actually_changed_ids) {
										if( m_cur_result.work_list_id != 0 ) {
											triggerFilter();
										}
									});
									showInfoToast(mjt('add-media-to-category-canceled'));
								}
							});
						});
					}, function( error ) {
						drop_done();
						// TODO: localize error message:
						showWarningToast( 'Fehler, Kategorie konnte nicht zugewiesen werden. ' + error );
					} );
				};
				if( tree_info.multifiling && cat_id!=0 ) {
					// multifiling on tree is enabled,
					// -> choice between "add to" & "set to" category
					//var m_catmove_type = null;
					//var m_catmove_lastaction = null;

					if(m_catmove_lastaction) {
						clearTimeout(m_catmove_lastaction);
					}
					if(m_catmove_type === null) {
						confirm_box(mjt('move-media-to-category-title'),media_ids.length==1 ? mjt('move-media-to-category-mf-message-1') : mjt('move-media-to-category-mf-message').replace('%d',media_ids.length.toString()),
							function( opt_vals ) {
								var mf_addto = opt_vals.hasOwnProperty('addto') && !!opt_vals.addto;
								var mf_save = opt_vals.hasOwnProperty('save') && !!opt_vals.save;
								if(mf_save) m_catmove_type = !mf_addto;
								if(!mf_addto) {
									_move_to_cat(media_ids, tree_id, cat_id, m_cur_result, dtnode);
								} else if(m_catmove_type === false) {
									_add_to_cat(media_ids, tree_id, cat_id, m_cur_result, dtnode);
								}
							},
							[{ key:'addto', checked:true, title:mjt('move-media-to-category-opt-mf-addto') }, { key:'save', checked:true, title:mjt('move-media-to-category-opt-mf-savedecision') }],
							drop_done
						);
					} else if(m_catmove_type === true) {
						_move_to_cat(media_ids, tree_id, cat_id, m_cur_result, dtnode);
					} else {
						_add_to_cat(media_ids, tree_id, cat_id, m_cur_result, dtnode);
					}
					m_catmove_lastaction = setTimeout(function() {
						m_catmove_lastaction = null;
						m_catmove_type = null;
					}, 60000);
				} else {
					if(m_catmove_type !== null) {
						m_catmove_type = null;
						m_catmove_lastaction = null;
					}
					_move_to_cat(media_ids, tree_id, cat_id, m_cur_result, dtnode);
				}
			}
		},
		over: function esdt_cat_node_over( evt, ui ) {
			var dtnode = this.dtnode,
				dt = dtnode.tree;
			$('.drop-info',ui.helper).text( mjt('media-drop-on-category','!')+': '+dtnode.data.title);
			m_cat_node_droppable_hover_count ++;
			requestAnimationFrame( function esdt_cat_node_over2() {
				m_droppable_cat_nodes_auto_collapse(dt,dtnode,evt,true);
				if( dtnode.aChilds ) {
					if( dtnode.bExpanded ) {
						//m_droppable_cat_nodes_auto_collapse(dtnode.tree,dtnode,evt);
					} else {
						// auto-expand node
						dtnode.expand();
						// save in auto-expand list
						if( m_droppable_cat_nodes_auto_expanded_on_over.lastIndexOf(dtnode.data.key)===-1 ) m_droppable_cat_nodes_auto_expanded_on_over.push(dtnode.data.key);
						// refresh drop targets positions
						if( $.ui.ddmanager ) $.ui.ddmanager.prepareOffsets( $.ui.ddmanager.current, evt );
					}
				}
			} );
		},
		out: function esdt_cat_node_out( evt, ui ) {
			// var dtnode = this.dtnode;
			if( -- m_cat_node_droppable_hover_count <= 0 ) {
				$('.drop-info',ui.helper).empty();
			}
		},
	};

	var m_cat_node_droppable_cfg_disabled = {
		accept: '.drag-media',
		addClasses: false,
		tolerance: 'pointer',
		activeClass: 'drop-disabled',
		over: function esdt_cat_node_disabled_over( evt, ui ) {
			var dtnode = this.dtnode;
			if( dtnode.aChilds && !dtnode.bExpanded ) {
				// expand node
				dtnode._expand(true);
				// refresh drop targets positions
				if( $.ui.ddmanager ) $.ui.ddmanager.prepareOffsets( $.ui.ddmanager.current, evt );
			}
		},
		out: function esdt_cat_node_disabled_out( evt, ui ) {
			// var dtnode = this.dtnode;
		},
	};

	function m_droppable_cat_nodes_update_visible_node( data, span, tree_id, tree_nodes_detached, is_browsing ) {
		var cat_id = data.key;
		var node_elem = null;
		if( tree_nodes_detached ) node_elem = $('#cat-node-dtn-'+tree_id+'-'+cat_id,span).get(0);
		else node_elem = document.getElementById('cat-node-dtn-'+tree_id+'-'+cat_id);
		if( node_elem ) {
			if( m_cc.loaded ) setCategoryCountHTML(node_elem,tree_id,cat_id,is_browsing);
			else node_elem.innerText = '';
		}
		if( data.xtype ) $(span).addClass(data.xtype);
		return cat_id;
	}

	function getDynatreeSkeletonHtml( tree ) {
		return '<div id="cat-tree-'+tree.tree_id+'" class="media-cat-tree'+(tree.multifiling?' multifiling':'')+(tree.metasearch_mode?' metasearch':'')+'"></div>';
	}


	function setupExtSearchDynatree( tree_id, is_initially_browsing, restore_selection, ondone ) {
		var tree=mj.trees[tree_id],
			tn=tree.nodes,
			tno=tree.nodes_order,
			tnolen=tno.length;
		// replace with a new div (this destroys previously active dynatree on that node)
		$('#cat-tree-'+tree_id).replaceWith( getDynatreeSkeletonHtml(tree) );
		// setup new dynatree on that node
		var ct_div = $('#cat-tree-'+tree_id);

		var tree_nodes;
		if( tree.metasearch_mode ) {
			tree_nodes = MDTrees.getDynatreeObjectFromTree(tree_id,false,false,false);
		} else {
			tree_nodes = MDTrees.getDynatreeObjectFromTree(tree_id,true,true,false);
		}

		ct_div.dynatree( {
			children: tree_nodes,
			persist: true,
			keyboard: false,
			cookieId: 'mj-cdt-s-'+tree_id,
			cookieOpts: mj.cookieopts,
			idPrefix: 'cat-node-'+tree_id+'-',
			mjTreeId: tree_id,
			multiSelect: tree.metasearch_mode ? true : ( m_cat_nav_mode!=='browse' ),
			autoSelectChildren: tree.metasearch_mode ? true : ( m_cat_nav_mode!=='browse' && !( tree.multifiling && tree.conjunct_mode ) ),
			nodeHTMLAppend: tree.metasearch_mode ? '' : ( '<span id="cat-node-dtn-'+tree_id+'-%key%" class="dtn"></span>' ),
			nodeHREF: mj.uwn+'/media#category=%key%',
			onSelect: function esdt_onSelect( dtnode ) {
				var i;
				if( m_cat_nav_mode==='browse' ) {
					// expand - show child categories
					dtnode._expand(true);
					// collapse all siblings (this avoids that the "whole tree" is expanded after some browsing through it)
					dtnode.collapseSiblings();
					// somehow, here the jquery ui tooltip widget does not update properly,
					// - so, remove all tooltips manually ...
					closeAllTooltips();
					// unselect all other categories in other trees
					var tol=mj.trees_order.length;
					for( i=0; i<tol; ++i ) {
						var other_tree_id=mj.trees_order[i];
						if( other_tree_id!=tree_id ) {
							var tnode = $('#cat-tree-'+other_tree_id);
							if( tnode.length ) tnode.dynatree('getTree').unselectAllNodes();
						}
					}
				} else if( tree.multifiling && tree.conjunct_mode ) {
					// avoid multi-select sets consisting of regular categories together with the "unsorted" category...
					var dt = ct_div.dynatree('getTree'),
						selected_keys = dt.getSelectedKeys(), // = array( cat_id, cat_id, ... )
						skl = selected_keys.length,
						selected_cat_id = dtnode.data.key;
					for( i=0; i<skl; ++i ) {
						if( selected_keys[i]==0 ) {
							// found cat_id=0 in selection set => dismiss whole selection set & select the last selected item only!
							dt.selectSingleNodeByKey( selected_cat_id );
							break;
						}
					}
				}
				onCategorySelectionChange(true,true);
			},
			onAfterRecursiveNodeUpdate: function esdt_onAfterRecursiveNodeUpdate( div, span ) {
				var is_browsing = isCategoryBrowsing();
				var tree_nodes_detached = this.tree.getTreeNodesDetached();
				if( mj.role_manager ) {
					var enabled_drop_targets = [];
					var disabled_drop_targets = [];
					this.visit2( function esdt_onAfterRecursiveNodeUpdate_visit1( div, span, is_visible ) {
						if( is_visible ) {
							var cat_id = m_droppable_cat_nodes_update_visible_node(this.data,span,tree_id,tree_nodes_detached,is_browsing);
							if( cat_id ) {
								var can_drop = tree_id!=1 || cat_id==0 || arr_inArray(cat_id,mj.upload_categories)!=-1;
								if( can_drop ) enabled_drop_targets.push(span);
								else disabled_drop_targets.push(span);
							}
						} else {
							var $span = $(span);
							if( $span.droppable('instance') ) $span.droppable('destroy');
						}
					} );
					if( enabled_drop_targets.length ) $(enabled_drop_targets).droppable(m_cat_node_droppable_cfg_enabled);
					if( disabled_drop_targets.length ) $(disabled_drop_targets).droppable(m_cat_node_droppable_cfg_disabled);
				} else {
					this.visit2( function esdt_onAfterRecursiveNodeUpdate_visit1( div, span, is_visible ) {
						if( is_visible ) m_droppable_cat_nodes_update_visible_node(this.data,span,tree_id,tree_nodes_detached,is_browsing);
					} );
				}
			},
			onAfterDelayedCreate: function esdt_onAfterDelayedCreate( dt ) {
				var i, cid, cnode, dtnode;
				var root = dt.getRoot(),
					is_browsing = is_initially_browsing,
					tree_nodes_detached = dt.getTreeNodesDetached();
				if( mj.role_manager ) {
					var enabled_drop_targets = [], disabled_drop_targets = [];
					root.visitChildren2( function esdt_onAfterDelayedCreate_visit1( div, span, is_visible ) {
						if( is_visible ) {
							var cat_id = m_droppable_cat_nodes_update_visible_node(this.data,span,tree_id,tree_nodes_detached,is_browsing);
							if( cat_id ) {
								var can_drop = tree_id!=1 || cat_id==0 || arr_inArray(cat_id,mj.upload_categories)!=-1;
								if( can_drop ) enabled_drop_targets.push(span);
								else disabled_drop_targets.push(span);
							}
						}
					} );
					if( enabled_drop_targets.length ) $(enabled_drop_targets).droppable(m_cat_node_droppable_cfg_enabled);
					if( disabled_drop_targets.length ) $(disabled_drop_targets).droppable(m_cat_node_droppable_cfg_disabled);
				} else {
					root.visitChildren2( function esdt_onAfterDelayedCreate_visit2( div, span, is_visible ) {
						if( is_visible ) m_droppable_cat_nodes_update_visible_node(this.data,span,tree_id,tree_nodes_detached,is_browsing);
					} );
				}
				// expand the first top level node
				for( i=0; i<tnolen; ++i ) {
					cid = tno[i];
					cnode = tn[cid];
					if( cnode && cnode.depth===1 ) {
						dtnode = dt.getNodeByKey(cid);
						if( dtnode!==null ) dtnode.makeVisible();
						break;
					}
				}
				if( restore_selection ) {
					// m_filter.categories -> select all those nodes
					var select_categories = m_filter.categories.slice(0);
					// m_filter.not_in_trees -> select unsorted nodes
					for( i=0; i<m_filter.not_in_trees.length; ++i ) {
						if( m_filter.not_in_trees[i]==tree_id ) select_categories.push(0);
					}
					// select categories from m_filter.metasearch_values...
					for( i=0; i<m_filter.metasearch_values.length; ++i ) {
						if( m_filter.metasearch_values[i].tree_id==tree_id ) select_categories.push( m_filter.metasearch_values[i].cat_id );
					}
					dt.setSelection(select_categories,true);
				}
				if( ondone ) ondone();
			},
		} );

		// setup contextmenu on category nodes
		MVTrees.setupContextMenuOnCategoryTree( ct_div, "category" );

	}


	function refreshCategoryTree( tree_id, force_update_category_counts, ondone ) {
		var is_initially_browsing = isCategoryBrowsing();
		setupExtSearchDynatree( tree_id, is_initially_browsing, true, function refreshCategoryTree_setupExtSearchDynatree_ondone() {
			triggerFilter(force_update_category_counts,ondone);
		} );
	}

	function refreshCategoryTree2( tree_id, create_nodes, update_nodes, delete_nodes, ondone ) {
		var i, data, parent_dtnode;
		var dt = $('#cat-tree-'+tree_id).dynatree('getTree');
		for( i=0; i<create_nodes.length; ++i ) {
			data = create_nodes[i];
			parent_dtnode = dt.getNodeByKey(data.parent);
			if( parent_dtnode!==null ) {
				var ndata = mj_cloned_object(data);
				delete ndata.parent;
				delete ndata.after;
				parent_dtnode._addNode(ndata,data.after);
			}
		}
		for( i=0; i<update_nodes.length; ++i ) {
			data = update_nodes[i];
			var dtnode = dt.getNodeByKey(data.key);
			if( dtnode!==null ) {
				if( data.hasOwnProperty('title') ) {
					dtnode._updNode(data.title);
				}
			}
		}
		for( i=0; i<delete_nodes.length; ++i ) {
			data = delete_nodes[i];
			parent_dtnode = dt.getNodeByKey(data.parent);
			if( parent_dtnode!==null ) {
				parent_dtnode._delNode(data.key);
			}
		}
		triggerFilter(true,ondone);
	}


	function setSearchStringMultiline( set_open, save, initial, set_focus ) {
		var was_open = isSearchStringMultiline();
		if( typeof set_open === 'undefined' || set_open===null ) set_open = !was_open;
		else set_open = !!set_open;
		if( save ) {
			var new_sess_val = set_open ? '1' : '0';
			if( new_sess_val !== getFromSession('search_fulltext_multiline',null) ) setInSession('search_fulltext_multiline',new_sess_val);
		}
		if( initial || set_open!==was_open ) {
			$('#search-toggle-multi-1').toggle(!set_open);
			$('#search-toggle-multi-2').toggle(set_open);
			m_search_string_elem.toggle(!set_open);
			$('#search-ml-string,#search-ml-controls').toggle(set_open);
			$('#left-media-1,#search-1,#search-3,#search-wrapper').toggleClass('search-ml',set_open);
			if( set_open ) {
				// convert single-line to multi-line term
				var mstr = convertSearchStringToMultilineInput(m_search_string_elem.val());
				m_search_string_ml_elem.val(mstr);
			} else {
				// convert multi-line to single-line term
				var sstr = convertMultilineInputToSearchString(m_search_string_ml_elem.val());
				m_search_string_elem.val(sstr);
			}
			if( save ) {
				MVPageHistory.go('sr',getSearchRequest(true).getTransientState(),'suppress');
				//return;
			}
		}
		if( set_focus ) m_search_string_both_elems.filter(':visible').focus().select();
	}


	function isExtSearchOpened() {
		return $('#search-3').css('display') !== 'none';
	}

	function setExtSearchOpened( set_open, save, initial, ondone ) {
		var i;
		if( m_tes_ignore ) return false; // toggle in progress
		const was_open = isExtSearchOpened();
		if( typeof set_open === 'undefined' || set_open===null ) set_open = !was_open;
		else set_open = !!set_open;
		if( save ) setInSession('extended_search_opened',set_open?'1':'0');
		if( initial || set_open!==was_open ) {
			m_tes_ignore = true;
			if( initial ) {
				$('#search-3').toggle(set_open);
				$('#extended-search-toggle-1').toggle(set_open);
				$('#extended-search-toggle-2').toggle(!set_open);
				m_tes_ignore=false;
			} else if( set_open!==was_open ) {
				$('#search-3').slideToggle( 'fast', function() {
					$('#extended-search-toggle-1').toggle(set_open);
					$('#extended-search-toggle-2').toggle(!set_open);
					m_tes_ignore=false;
				} );
			}
			var post_setup_list = [];
			if( set_open ) {
				// setup category trees
				var is_initially_browsing = isCategoryBrowsing();
				var tol = mj.trees_order.length;
				for( i=0; i<tol; ++i ) {
					var tree_id=mj.trees_order[i], tnode=mj.trees[tree_id];
					if( tnode.visible ) post_setup_list.push( [tree_id,is_initially_browsing] );
				}
			} else if( resetExtSearch(true) ) {
				triggerSearch();
			}
			m_search_string_both_elems.filter(':visible').focus().select();
			var psli_todo = post_setup_list.length;
			const setExtSearchOpened_setupExtSearchDynatree_ondone = function() {
				if( --psli_todo == 0 ) {
					if( ondone ) ondone();
				}
			};
			if( psli_todo > 0 ) {
				for( i=0; i<post_setup_list.length; ++i ) {
					var psli = post_setup_list[i];
					setupExtSearchDynatree( psli[0], psli[1], false, setExtSearchOpened_setupExtSearchDynatree_ondone );
				}
			} else if( ondone ) {
				ondone();
			}
		}
	}

	function updateResult( cr ) {
		//console.log(['MVSearch.updateResult',m_cur_result,cr,updateResult.caller]);
		cr.work_count = parseInt(cr.work_count,10);
		cr.result_count = parseInt(cr.result_count,10);
		if( !cr.hasOwnProperty('text_result_count') ) cr.text_result_count = m_cur_result.text_result_count; // keep previous value
		cr.text_result_count = parseInt(cr.text_result_count,10);
		m_cur_result = cr;
		//console.log(['updateResult',JSON.stringify(cr),JSON.stringify(m_cur_result)]);
		loadCurrentSearchResultIntoResultView();
	}

	function loadCurrentSearchResultIntoResultView() {
		m_form.children('input[name=work_list_id]').val(m_cur_result.work_list_id);
		m_form.children('input[name=result_list_id]').val(m_cur_result.result_list_id);

		// // TODO: handle metasearch_values ..
		// // eslint-disable-next-line
		// console.log('TODO: loadCurrentSearchResultIntoResultView: handle metasearch_values too!');

		if( m_cur_result.work_list_id==0 ) {
			m_result_view_widget.loadEmpty('search');
		} else if( m_filter.not_in_trees.length===1 && m_filter.categories.length===0 ) {
			// any mode -> result view on unassigned media
			m_result_view_widget.loadSearchResult( m_cur_result.work_list_id, m_filter.not_in_trees[0], 0, m_cur_result.work_count );
		} else if( m_cat_nav_mode==='browse' && m_filter.in_trees.length===1 && m_filter.categories.length===1 ) {
			// 'browse' mode -> result view represents contents of exactly one category, it may contain category & media items
			m_result_view_widget.loadSearchResult( m_cur_result.work_list_id, m_filter.in_trees[0], m_filter.categories[0], m_cur_result.work_count );
		} else {
			// 'filter' mode -> result view contains media items only
			m_result_view_widget.loadSearchResult( m_cur_result.work_list_id, null, null, m_cur_result.work_count );
		}

		if( m_cur_result.hasOwnProperty('text_result_count') ) {
			var tcnt = m_cur_result.text_result_count; // = result count of text search
			$('#extended-search-toggle-text').text( tcnt==1 ? mjt('ext-search-text-result-count-1') : ( mjt('ext-search-text-result-count').replace('%d',tcnt.toString()) ) );
		}
		if( m_cur_result.hasOwnProperty('result_count') ) {
			var rcnt = m_cur_result.result_count; // = result count before applying category filter
			$('#trees-title .text').text( rcnt==1 ? mjt('media-categories-count-1') : ( mjt('media-categories-count').replace('%d',rcnt.toString()) ) );
		}
	}



	function getPostData() {
		_update_m_filter();

		// ensure proper sync between multiline and normal search term input
		if( isSearchStringMultiline() ) m_search_string_elem.val(convertMultilineInputToSearchString(m_search_string_ml_elem.val()||''));
		else m_search_string_ml_elem.val(convertSearchStringToMultilineInput(m_search_string_elem.val()||''));

		var r = m_form.serialize();
		r += '&in_categories=' + m_filter.categories.join(',');
		r += '&in_trees=' + m_filter.in_trees.join(',');
		r += '&not_in_trees=' + m_filter.not_in_trees.join(',');

		r += '&metasearch_trees=' + m_filter.metasearch_trees.join(',');
		r += '&metasearch_values=' + JSON.stringify(m_filter.metasearch_values);

		r += '&conjunct_mode_trees=' + ( m_cat_nav_mode==='browse' ? '' : m_conjunct_mode_trees.join(',') );

		r += '&view_sort=' + encodeURIComponent(getFromSession('view_sort'));
		r += '&auto_update_list_ids=1';
		return r;
	}


	function triggerReset( trigger_inplace ) {
		MVPageHistory.go('sr','',trigger_inplace?'replace':'suppress');
		if( trigger_inplace ) doReset();
	}

	function triggerSearchByRequestObject( search_info_obj, trigger_inplace, inplace_done_cb, force_trigger, auto_close_colors, auto_close_options, auto_close_categories ) {
		// console.log( ['MVSearch.triggerSearchByRequestObject',search_info_obj, trigger_inplace, inplace_done_cb, force_trigger, auto_close_colors, auto_close_options, auto_close_categories] );
		const go_val = search_info_obj.deflatedForURLRequest().getTransientState();
		MVPageHistory.go('sr',go_val,trigger_inplace?'replace':(force_trigger?'force':'suppress'));
		if( trigger_inplace ) {
			const trigger_sr_obj = search_info_obj;
			const close_colors = auto_close_colors && !trigger_sr_obj.hasColors();
			const close_options = auto_close_options && !trigger_sr_obj.hasOptions();
			const close_categories = auto_close_categories && !trigger_sr_obj.hasCategoriesFilter();
			doTriggerSearchByRequestObject( trigger_sr_obj, inplace_done_cb, close_colors, close_options, close_categories );
		}
	}

	function triggerSearch( force_trigger ) {
		//console.log(['MVSearch.triggerSearch',force_trigger]);
		triggerSearchByRequestObject(getSearchRequest(),false,null,force_trigger);
	}

	function triggerFilter( force_update_category_counts, ondone ) {
		if( m_trigger_freezed ) return;
		if( m_cur_result.work_list_id==0 || getSearchString()==='' ) {
			setSearchString('*',false);
			triggerSearch();
			return;
		}
		startProgress();
		function search_done() {
			stopProgress();
			if( ondone ) ondone();
			if( force_update_category_counts ) updateCategoryCounts();
		}
		postToBackend2( 'json/media/search-filter', getPostData(), function triggerFilter_response(j) {
			var j_valid = j!==false && !j.error;
			if( j_valid ) updateResult(j);
			search_done();
		}, search_done, search_done );
	}

	function triggerSearchByTag( tag, trigger_inplace ) {
		var sr = getSearchRequest();
		sr.setFulltextQuery(tag,false);
		if( m_cfg.search_by_tag_resets_extended_options ) {
			sr.removeColors();
			sr.removeOptions();
			sr.removeCategoriesFilter();
		}
		triggerSearchByRequestObject( sr, trigger_inplace,null,false, true,true,false );
	}



	function triggerSearchByMeta( data, meta_id, trigger_inplace ) {
		let sr = getSearchRequest();
		if( m_cfg.search_by_meta_resets_extended_options ) {
			sr.removeColors();
			sr.removeOptions();
			sr.removeCategoriesFilter();
		}
		let matched_an_option = false;
		if( m_cfg.search_by_meta_try_match_options ) {
			matched_an_option = MVSearchOptions.selectOptionForSearchByMeta(sr,data,meta_id);
		}
		if( matched_an_option ) {
			sr.setFulltextQuery('*',false);
		} else {
			let tag = '$'+meta_id;
			if( Array.isArray(data) ) {
				for( let i=0; i<data.length; ++i ) {
					tag += i===0 ? ' ' : ' | ';
					tag += '"'+String(data[i]).replace(/"'/g,' ')+'"';
				}
			} else {
				tag += ' "'+String(data).replace(/"'/g,' ')+'"';
			}
			sr.setFulltextQuery(tag,false);
		}
		triggerSearchByRequestObject( sr, trigger_inplace,null,false, true,true,false );
	}


	function triggerSearchByCategories( tag, categories, trigger_inplace, set_browse_mode, inplace_done_cb ) {
		var sr = getSearchRequest();
		sr.setFulltextQuery(tag,false);
		sr.removeCategoriesFilter();
		sr.addFlatCategoriesList(categories);
		if( set_browse_mode ) sr.setBrowseMode(set_browse_mode);
		triggerSearchByRequestObject(sr,trigger_inplace,inplace_done_cb);
	}

	function triggerSearchByCategory( tree_id, cat_id, trigger_inplace, set_browse_mode, inplace_done_cb ) {
		triggerSearchByCategories('*',[[tree_id,cat_id]],trigger_inplace,set_browse_mode,inplace_done_cb);
	}

	function triggerFilterSetCategory( tree_id, cat_id ) {
		if( tree_id===null ) tree_id = MDTrees.getTreeIdFromCategoryId(cat_id);
		var dt = $('#cat-tree-'+tree_id);
		if( dt && dt.length ) {
			var dti = dt.dynatree('instance');
			dt = dti ? dti.getTree() : null;
			if( dt && ('getNodeByKey' in dt) ) {
				var n = dt.getNodeByKey(cat_id);
				if( n ) {
					n.makeVisible();
					n.select(null,true,false);
				}
			}
		}
	}

	function triggerSearchBySimilarity( media_ids, trigger_inplace ) {
		var tag = '~'+media_ids.join(',');
		triggerSearchByTag(tag,trigger_inplace);
	}


	function doReset() {
		m_cur_search_info_obj = null;
		resetExtSearch(false,true);
		setSearchString('',false,false);
		MVSearchConstraints.selectDefaultTerms(false);
		updateResult({result_list_id:0,work_list_id:0,text_result_count:0,result_count:0,work_count:0});
	}

	/**
	 *  NOTE: this will replace & deprecate most of the other trigger* functions
	 **/
	function doTriggerSearchByRequestObject( search_info_obj, ondone, close_colors, close_options, close_categories ) {

		if( m_trigger_freezed ) return;
		m_trigger_freezed = true; // avoids search triggered while applying changes to search form

		m_cur_search_info_obj = search_info_obj.createCopy();

		let searchRequestState = search_info_obj.getState();
		const ac_enabled = disableAutocomplete();
		startProgress();
		function search_done() {
			stopProgress();
			if( ac_enabled ) enableAutocomplete();
			if( ondone ) ondone();
		}

		// -> mode = filter|browse
		if( searchRequestState.mode!==null && searchRequestState.mode!==m_cat_nav_mode ) setCategoryNavigationMode( searchRequestState.mode, true,false, false,true,false );

		// -> Read Only: is_category_browsing
		// nothing

		// -> fulltext
		if( searchRequestState.fulltext!==null ) setSearchString(searchRequestState.fulltext,false,false);
		if( searchRequestState.fulltext_multiline!==null ) setSearchStringMultiline(searchRequestState.fulltext_multiline,true,false,false);
		defaultToStar();

		MVSearchConstraints.setSelectedTerms(searchRequestState.constraints,false);


		let _tryStep3State = {
			mayStartNow: false,
			preconditions: 0,
			timeout_id: null,

			tryExec( do_timed_call, is_timed_call ) {
				if( _tryStep3State.timeout_id!==null ) {
					clearTimeout(_tryStep3State.timeout_id);
					_tryStep3State.timeout_id = null;
				}
				if( _tryStep3State.mayStartNow && _tryStep3State.preconditions===0 ) {
					postToBackend2( 'json/media/search', getPostData(), function(j) {
						const j_valid = j!==false && !j.error;
						if( j_valid ) updateResult(j);
						search_done();
						if( j_valid ) {
							if( m_cat_nav_mode==='browse' && getSearchString()==='*' && m_filter.categories.length!==0 ) {
								// do not display result count info
							}
							requestAnimationFrame( function() {
								updateCategoryCounts();
							} );
						}
					}, search_done, search_done );
				} else if( do_timed_call ) {
					// DEFERED NEXT CALL ...
					_tryStep3State.timeout_id = setTimeout(function() {
						_tryStep3State.tryExec(true,true);
					},48);
				}
			},
		};

		function _doStep2() {
			// -> colors
			resetColors();
			var color_filter_active = false;
			if( searchRequestState.colors.length>0 ) {
				let active_colors = 0;
				for( let ci=0; ci<searchRequestState.colors.length; ++ci ) if(searchRequestState.colors[ci]) active_colors++;
				if(active_colors) {
					resetColors(active_colors+1);
					let idx = 0;
					for( let ci=0; ci<searchRequestState.colors.length; ++ci ) if(searchRequestState.colors[ci]) setColor(idx++,searchRequestState.colors[ci],false);
				}

				color_filter_active = updateColorsActiveMarker();
			}
			if( close_colors || color_filter_active ) toggle_oc_container('search-ext-colors',color_filter_active);


			// -> options
			const options_filter_active = MVSearchOptions.participateInTriggerSearchByRequestObject( searchRequestState, _tryStep3State );
			if( close_options || options_filter_active ) toggle_oc_container('search-ext-options',options_filter_active);


			// -> in_trees
			// -> in_categories
			// -> not_in_trees
			// -> metasearch_trees
			// -> metasearch_values
			deselectTrees(false,false,true);
			m_filter = search_info_obj.getCategoryXFilter();

			setCategorySelectionStates( search_info_obj.getFlatCategoriesList(), search_info_obj.getMetaSearchValues() );

			var category_filter_active = true;
			if( close_categories || category_filter_active ) toggle_oc_container('search-ext-trees',category_filter_active);

			m_trigger_freezed = false;
			onCategorySelectionChange(false,false);

			_tryStep3State.mayStartNow = true;
			_tryStep3State.tryExec(true,false);
		}

		requestAnimationFrame( function() {
			// show ext search, if not yet opened...
			if( isExtSearchOpened() ) _doStep2();
			else setExtSearchOpened(true,true,false,_doStep2);
		} );
	}


	function activateDropTargets( activate, evt, ui ) {
		if( mj.role_manager ) {
			$('#trees-content').toggleClass( 'drop-active', activate );
			var tol=mj.trees_order.length;
			for( var i=0; i<tol; ++i ) {
				var tree_id=mj.trees_order[i],
					tnode = $('#cat-tree-'+tree_id);
				if( tnode.length ) {
					var dt = tnode.dynatree('getTree');
					m_droppable_cat_nodes_activate(dt,activate,evt,ui);
				}
			}
		}
	}

	function getFocusableNodes() {
		let $res_nodes = m_search_string_both_elems.filter(':visible');
		const $sopts_nodes = MVSearchOptions.getFocusableNodes();
		$res_nodes = $res_nodes.add($sopts_nodes);
		return $res_nodes;
	}


	function getFocusedElementNode() {
		if( document.activeElement ) {
			if( elementHasOneOfClassNames(document.activeElement,['search-string','search-ml-string']) ) return document.activeElement;
			if( MVSearchOptions.containsElement(document.activeElement) ) return document.activeElement;
		}
		return null;
	}

	function hasFocus() {
		//console.log(['MVSearch.hasFocus',document.activeElement]);
		if( document.activeElement ) {
			if( elementHasOneOfClassNames(document.activeElement,['search-string','search-ml-string']) ) return true;
			if( MVSearchOptions.containsElement(document.activeElement) ) return true;
		}
		return false;
	}

	function looseFocus() {
		var fn = getFocusedElementNode();
		if( fn ) $(fn).blur();
		//var sfn = getFocusableNodes();
		//if( sfn.is(':focus') ) sfn.blur();
	}

	function setFocus() {
		if( !hasFocus() ) getFocusableNodes().first().focus();
		//var sfn = getFocusableNodes();
		//if( !sfn.is(':focus') ) sfn.first().focus();
	}


	function getSearchRequest( for_url ) {
		var r = {};
		r.fulltext = getSearchString();
		r.fulltext_multiline = isSearchStringMultiline();
		r.constraints = MVSearchConstraints.getSelectedTerms();
		r.mode = m_cat_nav_mode;

		MVSearchOptions.updateSearchRequestState(r);

		r.colors = [];
		if( $('#domcol-content > .search-colors input').length ) {
			$('#domcol-content > .search-colors input').each(function() {
				if($(this).val()) {
					r.colors.push($(this).val());
				}
			});
		}

		_update_m_filter();
		r.in_trees = m_filter.in_trees;
		r.in_categories = m_filter.categories;
		r.not_in_trees = m_filter.not_in_trees;
		r.metasearch_trees = m_filter.metasearch_trees;
		r.metasearch_values = m_filter.metasearch_values;
		r.conjunct_mode_trees = m_cat_nav_mode==='browse' ? [] : m_conjunct_mode_trees;

		var sr = createSearchRequest(r).normalized();
		if( for_url ) sr = sr.withCategoriesDeflated().deflatedForURLRequest();

		var transient_title = m_cur_search_info_obj===null ? '' : m_cur_search_info_obj.getTransientTitle();
		var object_id = m_cur_search_info_obj===null ? '' : m_cur_search_info_obj.getObjectId();
		var additional_data = m_cur_search_info_obj===null ? '' : m_cur_search_info_obj.getAdditionalData();
		if( transient_title ) sr.setTransientTitle(transient_title);
		if( object_id ) sr.setObjectId(object_id);
		if( additional_data ) sr.setAdditionalData(additional_data);

		return sr;
	}

	function isValid() {
		return m_form !== null;
	}

	return {
		init: init,

		triggerReset: triggerReset,
		triggerSearchByRequestObject: triggerSearchByRequestObject,
		triggerSearch: triggerSearch,
		triggerFilter: triggerFilter,
		triggerSearchByTag: triggerSearchByTag,
		triggerSearchByMeta,
		triggerSearchByCategories: triggerSearchByCategories,
		triggerSearchByCategory: triggerSearchByCategory,
		triggerFilterSetCategory: triggerFilterSetCategory,
		triggerSearchBySimilarity: triggerSearchBySimilarity,

		doReset: doReset,
		doTriggerSearchByRequestObject,

		updateCategoryCounts: updateCategoryCounts,
		getSelectedCategories: function() {
			return m_filter.categories;
		},
		getResultInfo: function() {
			return m_cur_result;
		},
		activateDropTargets: activateDropTargets,

		getFocusableNodes: getFocusableNodes,
		// getFocusableNodesWhichDontBubbleKeydownEvents,
		getFocusedElementNode: getFocusedElementNode,
		hasFocus: hasFocus,
		looseFocus: looseFocus,
		setFocus: setFocus,

		refreshCategoryTree: refreshCategoryTree,
		refreshCategoryTree2: refreshCategoryTree2,

		loadCurrentSearchResultIntoResultView,
		getSearchRequest,
		isValid: isValid,
	};
}(jQuery,mj); // namespace MVSearch


// support for onclick="MVSearch....",
window.MVSearch = MVSearch;
